export default __webpack_public_path__ + "static/media/profilepage-invite-accept.66244c4b.svg";